import { AfterDataHtmlS } from './AfterDataHtmlS';
import { AfterDataHtmlM } from './AfterDataHtmlM';

const NoDataHtml = () => {
  return <p>登録データがありません。</p>;
};

const ErrorDataHtml = () => {
  return <p>データを取得できませんでした。</p>;
};

export const DataHtml = (props: DataHtmlProps) => {
  if (props.data.length) {
    if (props.isTabletAndDesktop) {
      return <AfterDataHtmlM data={props.data} year={props.year} />; // data取得後PC用
    } else {
      return <AfterDataHtmlS data={props.data} year={props.year} thisMonth={props.thisMonth} />; // data取得後SP用
    }
  } else {
    if (props.data.length === 0) {
      return <NoDataHtml />;
    } else {
      return <ErrorDataHtml />;
    }
  }
};
